export const config = {
  tokens: {
    launchDarkly: process.env.LAUNCHDARKLY_CLIENT_SIDE_ID as string,
  },
} as const;
